<template>
    <div class="home-view">
        <div class="header-wrapper">
            <default-header :menu="contentPagesData?.header" />
        </div>

        <slot />

        <selected-region v-if="contentPagesStore?.statusRegionSelect" :data="contentPagesData" @close-button="() => closeModalRegion()" />
        <support v-if="contentPagesStore.supportShow" :data="contentPagesData?.contactBlock" @close-button="() => closeModalSupport()" />
        <ContactFormSection v-if="contentPagesStore.contactFormShow" @close="closeContactForm" />
        <ModalBlock v-model="contentPagesStore.showSuccessModal" class="success">
            <ModalSuccess />
        </ModalBlock>
        <ModalBlock v-model="contentPagesStore.showErrorModal" class="success">
            <ModalError />
        </ModalBlock>
        <loader v-if="loader" />
        <default-footer />
        <cookie-banner />
    </div>
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import { useContentPages } from '@/stores/homeStores';
import { liveText } from '@/utils/liveTex';

import SelectedRegion from '~~/components/ModalWindow/SelectedRegion.vue';
import Support from '~~/components/ModalWindow/Support.vue';
import ContactFormSection from '~~/sections/ContactForm/ContactFormSection.vue';
import DefaultHeader from '~~/components/Header/defaultHeader/DefaultHeader.vue';
import DefaultFooter from '~~/components/Footer/DefaultFooter.vue';
import CookieBanner from '~~/components/layouts/CookieBanner.vue';
import ModalBlock from '~/components/layout/ModalBlock.vue';
import ModalSuccess from '~/pages/index/components/ModalSuccess.vue';
import ModalError from '~/pages/index/components/ModalError.vue';
import { useLayout } from '~/stores/layoutStore.ts';
const runtimeConfig = useRuntimeConfig();
const loader = ref(false);

onMounted(async () => {
    contentPagesStore.updateSuccessModal(false);
    contentPagesStore.updateErrorModal(false);
    if (process.client) {
        liveText();
    }
});

const contentPagesStore = useContentPages();
const layoutStore = useLayout();

watch(() => contentPagesStore.showSuccessModal, (newValue) => {
    if (!newValue) {
        const body = document.querySelector('body');
        body.style.overflowY = null;
    }
});

const contentPagesData = computed(() => layoutStore.dataPageLayout);

const closeModalSupport = () => {
    contentPagesStore.updateStatusSupport(false);
    const body = document.querySelector('body');
    body.style.overflowY = null;
};

const closeContactForm = () => {
    contentPagesStore.updateStatusContactForm(false);
    const body = document.querySelector('body');
    body.style.overflowY = null;
};

const closeModalRegion = () => {
    const body = document.querySelector('body');
    body.style.overflowY = null;
    contentPagesStore.updateStatusRegionSelect(false);
};

const scrollToTop = () => {
    document.querySelector('body').scrollIntoView();
};
</script>

<style>
html,
body {
    scroll-behavior: smooth;
    margin: 0;
    padding: 0;
    font-family: 'Roboto';
    color: #2b2b2b;
    min-height: 100vh;
}
.home-view {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.header-wrapper {
    border-bottom: 1px solid #E4E6E7;
}

.main-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: space-between;
}
.main-layout-content {
    margin-bottom: auto;
}
.default_border_block {
    position: absolute;
    width: 100%;
    height: 100%;
}
.default_border {
    width: 40px;
    height: 40px;
    position: absolute;
}
.default_border_top_left {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    border-top: 1px solid #aaa;
    border-left: 1px solid #aaa;
}
.default_border_top_right {
    position: absolute;
    top: 0;
    right: 0;
    border-top: 1px solid #aaa;
    border-right: 1px solid #aaa;
}
.default_border_bottom_left {
    bottom: 0;
    left: 0;
    border-bottom: 1px solid #aaa;
    border-left: 1px solid #aaa;
}
.default_border_bottom_right {
    bottom: 0;
    right: 0;
    border-bottom: 1px solid #aaa;
    border-right: 1px solid #aaa;
}
.full-height {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
}
.link-with-arrow {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #48538b;
    font-size: 14px;
    line-height: 1;
}
.link-with-arrow::after {
    content: url('../assets/images/icons/link_arrow.svg');
    height: 1rem;
}
.link-with-arrow.reversed::after {
    display: none;
}
.link-with-arrow.reversed::before {
    content: url('../assets/images/icons/link_arrow.svg');
    height: 1rem;
    transform: rotate(180deg);
}
.footer_content_logo_info_pesonal_text_block {
    display: flex;
    flex-direction: column;
}
</style>
